import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Download, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  const includes = ['Recetario Saludable: +365 opciones', 'Bonus de Fases del ciclo', 'Bonus de Comidas saciantes', 'Bonus de Meal prep', 'Bonus de Postres'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-background rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-primary/20 relative" data-id="element-120">
          {/* Discount Badge */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-accent text-white px-6 py-2 rounded-full font-bold text-xl shadow-lg whitespace-nowrap" data-id="element-121">
            AHORRÁ MÁS DEL 60%
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-center text-charcoal mb-8 mt-4" data-id="element-122">
            ¡<span className="bg-yellow-200/60 px-1 rounded" data-id="element-123">Todo</span> lo que
            vas a obtener!
          </h2>

          <div className="space-y-4 mb-8 bg-white p-6 rounded-2xl border border-gray-100" data-id="element-124">
            {includes.map((item, index) => <div key={index} className="flex items-center space-x-3" data-id="element-125">
                <CheckCircle2 className="text-primary flex-shrink-0" size={24} data-id="element-126" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-127">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-128">
            <p className="text-xl font-bold text-charcoal mb-6" data-id="element-129">
              👉 Abrís, elegís y{' '}
              <span className="font-extrabold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-130">
                listo
              </span>
              .
            </p>

            <div className="flex flex-col items-center justify-center mb-6" data-id="element-131">
              <div className="text-gray-500 font-medium mb-1" data-id="element-132">
                Valor real: <PriceDisplay basePriceArs={59990} isCrossedOut data-id="element-133" />
              </div>
              <div className="text-5xl md:text-7xl font-bold text-primary" data-id="element-134">
                <PriceDisplay basePriceArs={19990} data-id="element-135" />
              </div>
            </div>

            <CTAButton className="w-full text-xl py-5" data-id="element-136">
              Quiero mi recetario completo
            </CTAButton>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600 font-medium pt-6 border-t border-gray-200" data-id="element-137">
            <div className="flex items-center" data-id="element-138">
              <Lock size={18} className="mr-2 text-gray-400" data-id="element-139" /> Pago seguro
            </div>
            <div className="flex items-center" data-id="element-140">
              <Download size={18} className="mr-2 text-gray-400" data-id="element-141" /> Descarga
              instantánea
            </div>
            <div className="flex items-center" data-id="element-142">
              <ShieldCheck size={18} className="mr-2 text-gray-400" data-id="element-143" /> Garantía
            </div>
          </div>

          {/* Fake Payment Icons */}
          <div className="flex justify-center gap-3 mt-6 opacity-60" data-id="element-144">
            <div className="bg-gray-200 px-3 py-1 rounded text-xs font-bold" data-id="element-145">
              VISA
            </div>
            <div className="bg-gray-200 px-3 py-1 rounded text-xs font-bold" data-id="element-146">
              MASTERCARD
            </div>
            <div className="bg-gray-200 px-3 py-1 rounded text-xs font-bold" data-id="element-147">
              AMEX
            </div>
            <div className="bg-gray-200 px-3 py-1 rounded text-xs font-bold" data-id="element-148">
              PAYPAL
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}